import React, { useEffect, useRef } from 'react'
import { PRIVILEGE_COMPARE_CONFIG } from '../constants'
import { usePrivilegeTracking } from '../hooks'
import NewBadge from './NewBadge'

const VERSIONS = ['免费版', '基础会员', '高级会员', '超级会员', '企业级会员']

interface CompareItem {
  label: string
  subLabel?: string
  subLabelStyle?: 'danger' | 'default'
  /** 设计稿 NEW 角标（AI 类新权益） */
  isNew?: boolean
  values: (string | boolean)[]
}

interface CompareCategory {
  category: string
  icon: string
  items: CompareItem[]
}

export default function PrivilegeCompare() {
  const { registerRef, durations, ...trackingState } = usePrivilegeTracking()

  useEffect(() => {
    console.log('Privilege Tracking State:', { durations, ...trackingState })
  }, [durations, trackingState])

  const renderValue = (value: string | boolean) => {
    if (value === true) {
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
        >
          <path
            d="M17.592 3C12.728 5.984 9.2 9.752 7.608 11.64L3.72 8.592L2 9.976L8.712 16.808C9.864 13.848 13.528 8.064 18 3.952L17.592 3Z"
            fill="#954F2A"
          />
        </svg>
      )
    }
    return <span style={{ color: '#444' }}>{value}</span>
  }

  return (
    <div className="privilegeCompare">
      <div className="compareTitle">版本对比</div>

      <div className="compareHeader">
        <div className="headerPlaceholder"></div>
        {VERSIONS.map((v, i) => (
          <div key={i} className="versionName">
            {v}
          </div>
        ))}
      </div>

      <div className="compareContent">
        {(PRIVILEGE_COMPARE_CONFIG as CompareCategory[]).map(
          (category, catIndex) => (
            <div
              key={catIndex}
              className="compareCategory"
              ref={registerRef(category.category)}
            >
              <div className="categoryTitle">
                <img src={category.icon} className="categoryIcon" alt="" />
                {category.category}
              </div>
              {category.items.map((item, itemIndex) => (
                <div
                  key={itemIndex}
                  className={`compareItem ${
                    item.subLabel ? 'hasSubLabel' : ''
                  }`}
                >
                  <div className="itemLabel">
                    <div className="labelText">
                      {item.label}
                      {item.isNew && <NewBadge />}
                    </div>
                    {item.subLabel && (
                      <div
                        className={`labelSubText ${item.subLabelStyle || ''}`}
                      >
                        {item.subLabel}
                      </div>
                    )}
                  </div>
                  <div className="itemValues">
                    {item.values.map((val, valIndex) => (
                      <div key={valIndex} className="valueCell">
                        {renderValue(val)}
                      </div>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          )
        )}
      </div>
    </div>
  )
}
